import {
  faBars as freeFasFaBars,
  faXmark as freeFasFaXmark
} from '@fortawesome/free-solid-svg-icons'

export default {freeFasFaBars, freeFasFaXmark}